import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'
import {
  DeleteAtsFileDocument,
  DeleteAtsFileMutation,
  GetAtsFeedbacksDocument,
} from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

interface Props {
  fileId: string
  onClose: () => void
}

export const DeleteAttachedFileModal = ({ fileId, onClose }: Props) => {
  const [deleteAtsFile] = useMutation(DeleteAtsFileDocument, {
    variables: { id: fileId },
    extractorFn: (data: DeleteAtsFileMutation) => data.atsMutations.deleteAtsFile,
  })

  const onDeleteAtsFile = async () => {
    const result = await deleteAtsFile({
      refetchQueries: [GetAtsFeedbacksDocument],
    })

    const handled = handleResult(result, () => undefined)
    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.removed_successfully'),
      })
      onClose()
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('ats.feedbacks.delete_feedback_attachment.error_message'),
      })
    }
  }

  return (
    <>
      <Modal
        title={i18n.t('ats.feedbacks.delete_feedback_attachment.title')}
        onClose={onClose}
        illustration={'delete'}
        description={i18n.t('ats.feedbacks.delete_feedback_attachment.description')}
        onSubmit={() => onDeleteAtsFile()}
        footer={
          <Box gap="s8" flexDirection="row" alignItems="center" justifyContent="flexEnd">
            <Button type="secondary" onClick={onClose}>
              {i18n.t('common.cancel')}
            </Button>

            <Button type="negative" submit>
              {i18n.t('common.destroy')}
            </Button>
          </Box>
        }
      />
    </>
  )
}
